const Style = {

  image: 'float-left mr-6 w-12 rounded-full',
  blockquote: 'overflow-hidden',
  cite: 'overflow-hidden block opacity-80 not-italic mt-4'

}

export default Style;